export const MID_PAGE_CTA_EXPERIMENT_NAME = 'blog_mid_page_cta_banner';
export const SIDEPOPS_EXPERIMENT_NAME = 'sidepop_case_study_blog';

export const midPageCtaExperimentPageList = new Set([
  '/top-programming-languages/',
  '/ai-chatbot-comparison/',
  '/dev-barometer-q4-the-ai-native-workforce/',
  '/git-github-and-gitlab-whats-the-difference/',
  '/how-to-develop-an-ai-system-steps/',
  '/best-ides-senior-software-engineers/',
  '/top-languages-for-ai/',
  '/react-spa-single-page-application/',
  '/all-about-low-code-platforms/',
  '/best-java-gui-frameworks/',
  '/top-development-frameworks/',
  '/php-charts/',
  '/the-pros-and-cons-of-open-source-software-a-guide-for-developers-and-executives/',
  '/best-react-ide-editors/',
  '/things-you-can-create-with-java/',
  '/spotify-engineering/',
  '/java-integration-testing/',
  '/php-websites/',
  '/software-support-people-with-disabilities/',
  '/famous-apps-built-with-javascript/',
  '/mobile-app-design/',
  '/top-mobile-development-frameworks/',
  '/twitter-tech-stack/',
  '/top-custom-software-development-companies/',
  '/hire-top-1-talent/',
  '/choosing-the-right-cms/',
  '/best-software-outsourcing-companies/',
  '/programming-languages-business-should-use/',
  '/7-tech-pain-points-to-resolve/',
  '/team-lead-roles-in-software-development/',
  '/software-anti-patterns/',
]);

export const sidepopsExperimentPageList = new Set<string>([
  '/ai-chatbot-comparison/',
  '/dev-barometer-q4-the-ai-native-workforce/',
  '/how-to-develop-an-ai-system-steps/',
  '/top-languages-for-ai/',
  '/top-programming-languages/',
  '/programming-languages-business-should-use/',
  '/famous-apps-built-with-javascript/',
  '/things-you-can-create-with-java/',
  '/best-java-gui-frameworks/',
  '/java-integration-testing/',
  '/php-charts/',
  '/php-websites/',
  '/react-spa-single-page-application/',
  '/git-github-and-gitlab-whats-the-difference/',
  '/best-ides-senior-software-engineers/',
  '/best-react-ide-editors/',
  '/top-development-frameworks/',
  '/all-about-low-code-platforms/',
  '/choosing-the-right-cms/',
  '/mobile-app-design/',
  '/top-mobile-development-frameworks/',
  '/spotify-engineering/',
  '/twitter-tech-stack/',
  '/software-anti-patterns/',
  '/the-pros-and-cons-of-open-source-software-a-guide-for-developers-and-executives/',
  '/top-custom-software-development-companies/',
  '/best-software-outsourcing-companies/',
  '/hire-top-1-talent/',
  '/7-tech-pain-points-to-resolve/',
  '/team-lead-roles-in-software-development/',
  '/software-support-people-with-disabilities/',
]);

export function retrieveExperimentIdsByPath(pathname: string) {
  const experimentsIds: string[] = [];
  if (midPageCtaExperimentPageList.has(pathname)) {
    experimentsIds.push(MID_PAGE_CTA_EXPERIMENT_NAME);
  }

  if (sidepopsExperimentPageList.has(pathname)) {
    experimentsIds.push(SIDEPOPS_EXPERIMENT_NAME);
  }

  return experimentsIds;
}
